import React from "react";
import Header from "../../components/Header";
import PageAskTeacherMain from "./AskTeacherMain";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import AskTeacherDetail from "./AskTeacherDetail";

export default function AskTeacher() {
    const { path } = useRouteMatch();

    return (
        <div>
            <Header />

            <Switch>
                <Route path={path} exact component={PageAskTeacherMain} />

                <Route
                    path={`${path}/:batchNo/:courseNo/:courseSeq/:uuid`}
                    exact
                    component={AskTeacherDetail}
                />
            </Switch>
        </div>
    );
}
